<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
  >
    <path
      fill="#13A2E8"
      fill-rule="evenodd"
      d="M5 0c1.174 0 2.303.414 3.195 1.155l.033-.291c.032-.294.295-.507.59-.474.295.032.507.296.475.59L9.11 2.644c-.03.275-.263.478-.532.478l-.06-.003-1.663-.182c-.294-.033-.507-.297-.475-.591.033-.294.297-.506.591-.475l.469.05c-.69-.546-1.55-.85-2.441-.85-2.166 0-3.929 1.763-3.929 3.93 0 2.165 1.763 3.928 3.929 3.928S8.929 7.166 8.929 5c0-.296.24-.536.535-.536.296 0 .536.24.536.536 0 2.757-2.243 5-5 5S0 7.757 0 5s2.243-5 5-5z"
    />
  </svg>
</template>